export const localStorageKeys = {
    ACCESS_TOKEN: '__IM_ADS_ACCESS_TOKEN__',
    CODE_VERIFIER: '__IM_ADS_CODE_VERIFIER__',
    CODE_CHALLENGE: '__IM_ADS_CODE_CHALLENGE__',
    REFRESH_TOKEN: '__IM_ADS_REFRESH_TOKEN__',
    CURRENT_ACCOUNT_ID: '__IM_ADS_CURRENT_ACCOUNT_ID__',
    LOGIN_TYPE: '__IM_ADS_LOGIN_TYPE__',
};
